
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 9l-4.203 1.833a2 2 0 01-1.6 0L7 9.003"}}),_c('path',{attrs:{"d":"M13.5 19H17a4 4 0 004-4V8a4 4 0 00-4-4H7a4 4 0 00-4 4v3.5M5.037 20.235c-.17.486.287.947.688.693l4.109-2.606c.221-.14.221-.504 0-.644l-4.109-2.606c-.4-.254-.859.207-.688.693M5 18H1"}})])
          )
        }
      }
    